import { Button, Result, Space, theme } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { SystemType } from '@/v1/main/domain/auth';
import { PageEmpty } from '@/v1/main/views/Empty';
import { useAuth } from '@/v1/main/views/Provider';

export const PageNotFound: React.FC = () => {
    const { t } = useTranslation(['interface', 'title']);
    const { loggedIn } = useAuth();
    const navigate = useNavigate();

    const onPrev = () => {
        navigate(-1);
    };

    const onRedirect = () => {
        navigate(`/${SystemType.WEB}/login`);
    };

    const {
        token: { colorBgContainer },
    } = theme.useToken();
    return (
        <Result
            icon={<PageEmpty />}
            extra={
                <Space>
                    {loggedIn && (
                        <Button onClick={onPrev}>
                            {t('action.prev_page', { ns: 'interface' })}
                        </Button>
                    )}
                    {!loggedIn && (
                        <Button onClick={onRedirect}>
                            {t('action.redirect_page', {
                                ns: 'interface',
                                page: t('page.user_management_login', {
                                    ns: 'title',
                                }),
                            })}
                        </Button>
                    )}
                </Space>
            }
            style={{
                background: colorBgContainer,
            }}
        />
    );
};
